module.exports = __webpack_public_path__ + "static/media/FileList.9afa7942.svg";